import camelCase from '../lib/camelCase';
import Immutable from 'immutable';

function transformObject(obj) {
    if (Array.isArray(obj)) {
        return obj.map(item => transformObject(item));
    }

    if (obj.createdAt) obj.createdAt = new Date(obj.createdAt);
    if (obj.updatedAt) obj.updatedAt = new Date(obj.updatedAt);
    if (obj.deletedAt) obj.deletedAt = new Date(obj.deletedAt);
    return obj;
}

function transformAddressbooksFromApi(payload) {
    const result = transformObject(camelCase(payload));
    return result.map(book => {
        if (book.locations) book.locations = transformObject(book.locations);
        return book;
    });
}

export function get(api) {
    return api.get(api.url('locations/addressbooks'), {
        transformResponse(json) {
            const response = JSON.parse(json);
            return response && response.payload
                ? Immutable.fromJS(transformAddressbooksFromApi(response.payload))
                : response;
        },
    });
}

export function create(api, name) {
    return api.post(api.url('locations/addressbooks'), { name }, {
        transformResponse(json) {
            const response = JSON.parse(json);
            return response && response.payload
                ? Immutable.fromJS(transformAddressbooksFromApi(response.payload))
                : response;
        },
    });
}

export function share(api, addressbook, email) {
    return api.post(api.url('locations/addressbooks/share'), { addressbook, email }, {
        transformResponse(json) {
            const response = JSON.parse(json);
            return response && response.payload
                ? Immutable.fromJS(transformObject(camelCase(response.payload)))
                : response;
        },
    });
}

export function promote(api, addressbook, user) {
    return api.post(api.url('locations/addressbooks/promote'), { addressbook, user }, {
        transformResponse(json) {
            const response = JSON.parse(json);
            return response && response.payload
                ? Immutable.fromJS(transformObject(camelCase(response.payload)))
                : response;
        },
    });
}

export function demote(api, addressbook, user) {
    return api.post(api.url('locations/addressbooks/demote'), { addressbook, user }, {
        transformResponse(json) {
            const response = JSON.parse(json);
            return response && response.payload
                ? Immutable.fromJS(transformObject(camelCase(response.payload)))
                : response;
        },
    });
}

export function remove(api, addressbook, user) {
    return api.post(api.url('locations/addressbooks/remove'), { addressbook, user }, {
        transformResponse(json) {
            const response = JSON.parse(json);
            return response && response.payload
                ? Immutable.fromJS(transformObject(camelCase(response.payload)))
                : response;
        },
    });
}

export function leave(api, addressbook) {
    return api.post(api.url('locations/addressbooks/leave'), { addressbook }, {
        transformResponse(json) {
            const response = JSON.parse(json);
            return response && response.payload
                ? Immutable.fromJS(transformObject(camelCase(response.payload)))
                : response;
        },
    });
}

export default {
    get,
    create,
    share,
    promote,
    demote,
    remove,
    leave,
};
